import React from 'react';
import { LinkProps } from 'react-router-dom';

import Styled from './RouterLink.styles';

type Props = {
  underlined?: boolean;
  children: React.ReactNode;
  fontSize?: string;
  onClick?: () => void;
} & Partial<Pick<LinkProps, 'to' | 'target'>>;

const RouterLink: React.FC<Props> = (props: Props) => {
  const {
    to,
    children,
    underlined,
    fontSize,
    onClick,
    target,
  } = props;

  return (
    <Styled.RouterLink
      to={to}
      target={target}
      onClick={onClick}
      style={{
        textDecoration: `${underlined ? 'underline' : 'None'}`,
        fontSize: `${fontSize || '14px'}`,
      }}
    >
      {children}
    </Styled.RouterLink>
  );
};

export default RouterLink;
